import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService, CoreProxyService, CoreTypes, FormValidatorService, IncidentTypes, LabelValue } from 'common-cloudstudio';
import { GearAppService } from 'common-gear';
import { Subscription } from 'rxjs';
import { IncidentService } from '../services/incident.service';
import { ToasterService } from 'angular2-toaster';

@Component({
  selector: 'app-communication',
  templateUrl: './communication.component.html',
  styleUrls: ['./communication.component.scss'],
})
export class CommunicationComponent implements OnInit, OnChanges, OnDestroy {
  today = new Date();
  @ViewChild("formElement") public _formElement: NgForm;
  @Input() displayOnModal: boolean = false;
  @Input() communicationID: number = 0;

  @Output() onCloseForm = new EventEmitter<any>();
  @Output() onError = new EventEmitter<any>();

  _communication: CoreTypes.ITS_Communication = new CoreTypes.ITS_Communication();
  _clientID: number;
  subscriptions: Subscription[] = [];
  _errorBackEnd: string = "";
  _errorMessage: string;
  _formStatus = 0;

  dateFrom: CoreTypes.DateTimeDT = {
    ...new CoreTypes.DateTimeDT(),
    Date: {
      Day: this.today.getDate(),
      Month: this.today.getMonth()+1,
      Year: this.today.getFullYear()
    },
    Time: {
      Hour: this.today.getHours(),
      Minute: this.today.getMinutes(),
      Second: this.today.getSeconds(),
      Millisecond: this.today.getMilliseconds(),
    }
  };
  _vialAxesList: LabelValue<number>[] = []
  _vialAxesFullList: CoreTypes.ITS_VialAxes[];
  _vialAxes: LabelValue<number>;

  _referenceList: LabelValue<string>[] = [];
  _reference: LabelValue<string>;

  _roadwayFullList: CoreTypes.ITS_Roadways[] = [];
  _roadwayList: LabelValue<number>[] = [];
  _roadway: LabelValue<number>;
  _trafficDirectionsFullList:CoreTypes.ITS_TrafficDirection[] = [];
  _trafficDirectionsList: LabelValue<number>[] = [];
  _trafficDirections: LabelValue<number>;
  _communicationTypeList: LabelValue<number>[] = [];
  _communicationTypes: LabelValue<number>;
  _subSectorList: LabelValue<number>[] = [];
  _subSector:  LabelValue<number>;
  _communicationIssuerFullList: CoreTypes.ITS_CommunicationIssuers[] = [];
  _communicationIssuerList: LabelValue<any>[] = [];
  _communicationIssuer: LabelValue<any>;
  _kilometer:number;
  issuerType = IncidentTypes.IssuerType;

  constructor(
    public _appService: AppService,
    public _gearAppService: GearAppService,
    private _coreProxyService: CoreProxyService,
    private incidentService: IncidentService,
    private cdRef:ChangeDetectorRef,
    public _formValidatorService: FormValidatorService,
    private _toasterService: ToasterService,

  ) { }

  ngOnInit() {
    this._clientID = this._appService.getClientID();
    this.subscriptions.push(this._appService.onClientSet.subscribe(clientId => {
      if (clientId === this._clientID) return;
      this._clientID = this._appService.getClientID();
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnChanges(data: SimpleChanges): void {
    this.getITSCommunicationByID();
  }
  
  initData() {
    this.getVialAxis();
    this.getITSRoadways();
    this.getTrafficDirection();
    this.getSubSectors();
    this.getCommunicationIssuers();
    this.getCommunicationTypes();
    this.updateCurrentDates();
  }

  getITSCommunicationByID() {
    if(this.communicationID) {
      this._coreProxyService.IncidentService.GetITSCommunicationByID(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        this.communicationID,
        data => {
          this._communication = data;
          this.initData();
        },
        err => {
          this._errorBackEnd = err.Message;
          this.onError.emit(this._errorBackEnd);
          this._formStatus = 2;
          this.initData();
        }
      )
    } else {
      this._communication = new CoreTypes.ITS_Communication();
      this.initData();
    }
   
  }

  async getVialAxis() {
    this._vialAxesFullList = await this.incidentService.getITSVialAxes();
    let items: LabelValue<number>[] = [];
    this._vialAxesFullList?.forEach((i) => {
      const item = {
        label: i.VialAxisName,
        value: i.VialAxisID,
      };
      items.push(item);
    });
    this._vialAxesList = items;
    this._vialAxes = this._vialAxesList.find(t => t.value == this._communication?.VialAxisID) ??  this._vialAxesList[0];
  }

  getITSRoadways() {
    this._roadwayList = [];
    this._roadwayFullList = [];
    this._roadway = null;
    this.cdRef.detectChanges();
    this.incidentService.getITSRoadways().then(async roadwayList => {
      this._roadwayFullList = roadwayList;
      this._roadwayList = await this.incidentService._roadwaysList.value;
      this._roadway = this._roadwayList.find(t => t.value == this._communication?.RoadwayID) ?? this._roadwayList[0];
      this.cdRef.detectChanges();
    });
  }
  
  async getTrafficDirection() {
    this._trafficDirectionsList = await this.incidentService.getITSTrafficDirections();
    this._trafficDirectionsFullList = await this.incidentService._trafficDirectionsList.value;
    this._trafficDirections = this._trafficDirectionsList.find(t => t.value == this._communication?.TrafficDirectionID) ?? this._trafficDirectionsList[0];
    this.cdRef.detectChanges();
  }

  async getSubSectors() {
    await this.incidentService.getSubSectors();
    this._subSectorList = await this.incidentService._subSectorsList.value;
    this._subSector = this._subSectorList.find(s => s.value === this._communication?.SubSectorID) ?? this._subSectorList[0];
    this.cdRef.detectChanges();
  }

  async getCommunicationIssuers() {
    let parameters: CoreTypes.ITS_CommunicationIssuerParameters = new CoreTypes.ITS_CommunicationIssuerParameters();
    parameters.IncludeEmergencyVehicles = true;
    parameters.IncludeIssuers = true;
    parameters.IncludeServices = true;
    parameters.IncludeVehicles = true;
    this._communicationIssuerFullList = await this.incidentService.getCommunicationIssuers(parameters);
    this._communicationIssuerList = await this.incidentService._issuersList.value;
    const filterIssuerList = (type: number) => 
      this._communicationIssuerList?.map(({ label, value }) => {
        const [id, issuerType] = value.split("-").map(Number);
        return issuerType === type ? { label, value: id } : null;
      }).filter(Boolean);
    
    const issuerLists = {
      [this.issuerType.CommunicationIssuer]: filterIssuerList(this.issuerType.CommunicationIssuer),
      [this.issuerType.Service]: filterIssuerList(this.issuerType.Service),
      [this.issuerType.Vehicle]: filterIssuerList(this.issuerType.Vehicle),
      [this.issuerType.EmergencyVehicle]: filterIssuerList(this.issuerType.EmergencyVehicle),
    };

    this._communicationIssuer = issuerLists[this._communication.CommunicationIssuerType]?.find(s => s.value === this._communication?.CommunicationIssuerID) ?? this._communicationIssuerList[0];
    this.cdRef.detectChanges();
  }

  async getCommunicationTypes() {
    await this.incidentService.getITSCommunicationTypes();
    this._communicationTypeList = await this.incidentService._communicationTypesList.value;
    this._communicationTypes =  this._communicationTypeList.find(x => x.value === this._communication.CommunicationType) ?? this._communicationTypeList[0];
  }

  updateCurrentDates() {
    this.today = new Date();
    this.dateFrom = {
      ...new CoreTypes.DateTimeDT(),
      Date: {
        Day: this.today.getDate(),
        Month: this.today.getMonth()+1,
        Year: this.today.getFullYear()
      },
      Time: {
        Hour: this.today.getHours(),
        Minute: this.today.getMinutes(),
        Second: this.today.getSeconds(),
        Millisecond: this.today.getMilliseconds(),
      }
    };
  }

  onSave(formElement) {
    if (formElement && !formElement.form.valid) {
      this._formElement.form.markAllAsTouched();
      this._errorBackEnd = this._formValidatorService.getValidationErrors(formElement);
      this.onError.emit(this._errorBackEnd);
      return;
    }
    this._formStatus = 1; // Loading

    if(this._vialAxes?.value) this._communication.VialAxisID = this._vialAxes.value;
    if(this._roadway?.value) this._communication.RoadwayID = this._roadway.value;
    if(this._trafficDirections?.value) this._communication.TrafficDirectionID = this._trafficDirections.value;
    if(this._subSector?.value) this._communication.SubSectorID = this._subSector?.value;
    if(this._communicationTypes?.value) this._communication.CommunicationType = this._communicationTypes.value;
    if(this._communicationIssuer?.value && typeof this._communicationIssuer?.value === 'string')  {
      const parts = this._communicationIssuer?.value?.split("-");
      this._communication.CommunicationIssuerID = parseInt(parts[0], 10);
      this._communication.CommunicationIssuerType = parseInt(parts[1], 10)
    }
    if(this.communicationID) {
      if(this.displayOnModal) {
        this.onCloseForm.emit(true);
      }
    } else {
      this._communication.ClientID = this._appService.getClientID();
      this._communication.CreatedByAccountID = this._appService.getAccountID();
      this._communication.FacilityID = this._appService.getFacilityID();
      this._communication.IncidentID = 0;
      this._coreProxyService.IncidentService.CreateITSCommunication(
        this._appService.getAccessToken(),
        this._appService.getFacilityID(),
        this._communication,
        data => {
          this._communication = data;
          this.incidentService.onRefreshCommunicationList.next(true);
          this._toasterService.pop('success', null, this._appService.CoreCommonLiterals.ChangesSavedSuccessfully + ' - ' + 'Comunicado' + ' #' + this._communication.CommunicationID);
          setTimeout(() => {
            this._formStatus = 0;
            if(this.displayOnModal) {
              this.onCloseForm.emit(true);
            }
          }, 200);
        },
        err => {
          this._errorBackEnd = err.Message;
          this.onError.emit(this._errorBackEnd);
          this._formStatus = 2;
        }
      )
    }
  }

}
